import { create } from 'zustand';

export type Selection =
  | { kind: 'mission' }
  | { kind: 'stage'; stageId: string }
  | { kind: 'maneuver'; maneuverId: string };

interface SelectionState {
  selection: Selection | null;
  select: (selection: Selection | null) => void;
}

/** What the Inspector panel currently shows, set by whatever panel the user clicked in. */
export const useSelectionStore = create<SelectionState>((set) => ({
  selection: null,
  select: (selection) => set({ selection }),
}));
